import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-percentage-input',
  imports: [],
  templateUrl: './form-percentage-input.component.html',
  styleUrl: './form-percentage-input.component.scss',
  standalone: false
})
export class FormPercentageInputComponent implements OnInit {
  @Input() title : string = '';
  @Input() value : number;
  @Output() valueChange : EventEmitter<number> = new EventEmitter<number>()
  public dvalue : string = ''
  private perc_symbol = '%'

  public ngOnInit(): void {
    const perc : string = (this.value*100).toFixed(2).replace(/\.00$/, '')
    this.dvalue = perc + this.perc_symbol
  }

  public onValueChanged(ev : string) : void {
    // console.log(ev)
      const clean : string = ev.replace(/[^0-9\.]/g, '')
      const num : number = parseFloat(clean)

      if (!isNaN(num)){
        this.value = num / 100;
        //this.dvalue = clean + this.perc_symbol
      }else{
        this.value = 0;
        this.dvalue ='' 
      }

      this.valueChange.emit(this.value)

  }

  public onFocus():void{
    this.dvalue = this.dvalue.replace(this.perc_symbol, '')
  }

  public onBlur():void{
    const clean : string = this.dvalue.replace(/[^0-9\.]/g, '')
    if(clean) this.dvalue = this.dvalue + this.perc_symbol
  }
}
